export const ru = {
  general: {
    home: "Начало",
    yes: "Да",
    no: "Нет",
    title: "Портал услуг Arbor",
    login: "Авторизоваться",
    logout: "Выйти",
    profile: "Профиль",
  },
  register: {
    title: "Регистры",
    equipment: {
      title: "Устройства",
      labels: {
        model: "Модель",
        clientInventoryNumber: "Номер инвентаря клиента",
        installationDate: "Дата установки",
        serviceProjectNumber: "Номер сервисного проекта",
        serviceContractNumber: "Номер контракта на обслуживание",
        projectCode: "Код проекта",
        saleContractNumber: "Номер договора купли-продажи",
        saleDocumentNumber: "Номер документа продажи",
        saleContractFile: "Файл договора купли-продажи",
        deviceData: "Информация об устройстве",
        clientData: "Информация о клиенте",
        manufacturerData: "Информация о производителе",
        serviceContractFile: "Файл контракта на обслуживание",
        manufacturerWarrantyExpirationDate: "Гарантия производителя до",
        manufacturerSupportExpirationDate: "Поддержка производителя до",
        warrantyExpirationDate: "Гарантийный срок (Арбор)",
        devicePackage: "Комплектация устройства",
        installations: "Установки",
        acquisitionDocumentNumber: "Номер документа производителя",
        acquisitionDocumentFile: "Файл документа производителя",
        acquisitionDocumentDate: "Дата документа производителя",
        orderNumber: "Номер заказа",
        department: "Отделение",
      },
      errors: {
        installationDateValidationMessage: "Это поле обязательно! Даты должны быть в порядке возрастания!",
        equipmentStateValidationMessage: "Статусы установки не могут повторяться! После списания установки невозможны!",
      },
      messages: {
        confirmSaveDeletePackage: "При удалении устройства, к которому привязаны компоненты, эти компоненты будут удалены с той же датой. Продолжить?",
        confirmSaveComponentDatesInvalid: "В комплектации устройства есть компоненты с датами установки, которые несовместимы с датой удаления устройства! При удалении устройства, к которому привязаны компоненты, эти компоненты будут удалены с той же датой. Продолжить?",
        confirmCopyInstallations: "Скопировать введённые установки на все устройства?",
        noEquipmentSelected: "Устройство не выбрано!",
      },
      actions: {
        copyInstallations: "Копировать установки",
      }
    },
    component: {
      title: "Компоненты",
      labels: {
        chooseDevice: "Выберите устройство",
        deviceData: "Данные устройства"
      },
      messages:{
        confirmCopyInstallations: "Скопировать введённые установки на все компоненты?",
      }
    },
    serviceAct: {
      title: "Сервисные акты",
      labels: {
        saveAsDraft: "Сохранить как черновик",
        branch: "Филиал",
        department: "Отделение",
        callNumber: "Номер вызова",
        dateTimeArrival: "Дата/время прибытия",
        dateTimeDeparture: "Дата/время отправления",
        workIsCompleted: "Работа закончена",
        workNotCompleted: "Работа не закончена",
        complaint: "Жалоба",
        workDone: "Выполненные работы",
        timeSpent: "Затраченное время",
        diagnostics: "Диагностика",
        functionalElectricalTest: "Проверка функциональной электробезопасности",
        installation: "Установка",
        repairs: "Ремонт",
        profilacticMaintenance: "Профилактическое обслуживание",
        training: "Обучение",
        clientConfirmation: "Подтверждение клиента",
        clientApproval: "Подтверждение клиента",
        serviceActPrintout: "Печать сервисного акта",
        actInformation: "Информация об акте",
        chooseEngineer: "Выберите инженера",
        usedPartsAndInstruments: "Использованные запасные части и измерительные приборы",
        neededPartsAndInstruments: "Необходимые запасные части и измерительные приборы",
        contractNumber: "Номер договора",
        conclusionRemarks: "Заключение/замечания",
        signature: "Подпись",
        engineers: "Инженеры",
      },
      actions: {
        addSignature: "Добавить подпись",
        deleteSignature: "Удалить подпись",
        confirmDeleteSignature: "Вы действительно хотите удалить подпись?",
      },
      messages: {
        serviceActApprovalSentSuccessfully: "Сервисный акт успешно отправлен на утверждение!",
      }
    },
    serviceActApproval: {
      labels: {
        serviceActRating: "Оценка сервисного акта",
        approveDate: "Дата подтверждения/отклонения",
        expireDateTime: "Действителен до",
      },
      actions: {
        approve: "Подтвердить",
        deny: "Отклонить",
        send: "Отправить",
        resend: "Отправить повторно",
      },
      messages: {
        confirmApprove: "Вы действительно хотите утвердить сервисный акт?",
        confirmDeny: "Вы действительно хотите отклонить сервисный акт?",
      }
    },
    call: {
      title: "Журнал вызовов",
      labels: {
        chooseDevice: "Выбрать устройство",
        addComponent: "Добавить компонент",
        issue: "Проблема",
        callNotificationType: "Тип уведомления",
        completed: "Выполнено/отклонено",
        serviceActs: "Сервисные акты",
        costs: "Затраты",
        invoiceNumber: "Номер счета",
      },
      actions: {
        createServiceAct: "Создать сервисный акт", 
      },
      messages: {
        copiedToClipboard: "Вызов успешно скопирован в буфер обмена!", 
      }
    },
    maintenance: {
      title: "Обслуживание",
      labels: {
        serviceAct: "Сервисный акт", 
        maintenanceType: "Тип обслуживания", 
        chooseEquipment: "Выбрать устройство/компонент", 
        maintenanceRequest: "Заявка на обслуживание", 
        warranty: "Гарантия",
      }
    },
    maintenanceCycle: {
      title: "Циклы обслуживания", 
      labels: {
        lastDoneDate: "Последняя дата выполнения", 
        plannedDate: "Запланировано", 
        maintenanceCount: "Количество проведённых обслуживаний", 
        period: "Период", 
        countPeriodFromPlannedDate: "Считать от даты первого обслуживания", 
      },
      actions: {
        addMaintenance: "Добавить обслуживание",
      },
      errors: {
        periodInvalid: "Период должен быть целым числом больше 0!"
      }
    },
    maintenanceRequest: {
      title: "Заявки на обслуживание", 
      labels: {
      }
    }
  },
  classifier: {
    title: "Классификаторы",
    equipmentmodel: {
      title: "Модели устройств",
    },
    equipmenttype: {
      title: "Типы устройств",
    },
    equipmentcategory: {
      title: "Категории устройств",
    },
    manufacturer: {
      title: "Производители",
      labels: {
        manufacturer: "Производитель",
      },
    },
    client: {
      title: "Клиенты",
      labels: {
        client: "Клиент",
      }
    },
    enduser: {
      title: "Конечные пользователи",
    },
    profession: {
      title: "Профессии",
    },
    person: {
      title: "Персоны",
      labels: {
        firstName: "Имя",
        lastName: "Фамилия",
        phone: "Номер телефона",
        email: "Электронная почта",
        profession: "Профессия",
      }
    },
    template: {
      labels: {
        sharedTemplate: "Общий шаблон",
      }
    }
  },
  administration: {
    title: "Администрация",
    administration: {
      title: "Администрация",
      labels: {
        passwordCurrent: "Текущий пароль",
        passwordNew: "Новый пароль",
        passwordConfirm: "Подтверждение пароля",
        changePassword: "Изменить пароль",
        users: "Пользователи",
        userData: "Данные пользователя",
        userPermissions: "Права пользователя",
        userRoles: "Роли пользователя",
        role: "Роль",
        roles: "Роли",
        rolePermissions: "Права ролей",
      },
    },
    printForm: {
      title: "Печать",
      labels: {
        parameters: "Параметры",
        settings: "Настройки печати",
        exportFormat: "Формат",
      },
      actions: {
        generatePreview: "Просмотр",
      }
    },
    report: {
      title: "Отчёты",
    }
  },
  common: {
    labels: {
      code: "Код",
      name: "Название",
      type: "Тип",
      serialNumber: "Серийный номер",
      client: "Клиент",
      endUser: "Конечный пользователь",
      state: "Статус",
      comments: "Комментарии",
      refNumber: "Референс №",
      active: "Активный",
      created: "Создан",
      category: "Категория",
      date: "Дата",
      attachments: "Вложения",
      attachmentsDrop: "или перетащите файлы сюда",
      file: "Файл",
      fileName: "Имя файла",
      user: "Пользователь",
      number: "Номер",
      status: "Статус",
      baseInformation: "Основная информация",
      engineers: "Инженеры",
      engineer: "Инженер",
      department: "Отделение",
      contractNumber: "Номер договора",
      devices: "Устройства",
      components: "Компоненты",
      minutes: "Минуты",
      quantity: "Количество",
      manufacturer: "Производитель",
      device: "Устройство",
      component: "Компонент",
      model: "Модель",
      clientInventoryNumber: "Номер инвентаря клиента",
      contact: "Контакт",
      contacts: "Контакты",
      contactInformation: "Контактная информация",
      id: "Id", 
      warranty: "Гарантия", 
      equipment: "Устройство/компонент", 
      dateTime: "Дата/время", 
      nameSurname: "Имя, Фамилия",
      preview: "Предпросмотр",
      email: "Электронная почта",
      isActive: "Активный",
      templates: "Шаблоны",
      editTemplate: "Изменить шаблон",
      content: "Содержание",
      person: "Человек",
      userName: "Имя пользователя",
      password: "Пароль",
      count: "Количество",
      group: "Группа",
      columnChooser: "Выбор колонок",
    },
    actions: {
      save: "Сохранить",
      delete: "Удалить",
      back: "Назад",
      search: "Поиск",
      new: "Новый",
      browse: "Обзор",
      download: "Скачать",
      copyToClipboard: "Копировать в буфер обмена", 
      createMaintenance: "Создать обслуживание",
      createMaintenanceCycle: "Создать цикл обслуживания",
      createMaintenanceRequest: "Создать заявку на обслуживание", 
      createCall: "Создать вызов",
      createServiceAct: "Создать сервисный акт", 
      add: "Добавить",
      edit: "Редактировать",
      create: "Создать",
      apply: "Применить",
      cancel: "Отменить",
      chooseDevice: "Выбрать устройство",
      chooseComponent: "Выбрать компонент",
      copy: "Копировать",
      import: "Импортировать",
      export: "Экспорт",
      clearFilters: "Очистить фильтры",
    },
    messages: {
      saved: "Сохранено",
      confirmDelete: "Запись будет удалена. Продолжить?",
      deleted: "Удалено",
      noData: "Нет записей",
    },
    errors: {
      valueEmpty: "Это поле обязательно для заполнения!",
      requiredFieldsEmpty: "Не все обязательные поля заполнены!",
      dateInvalid: "Введённое значение не соответствует формату даты/времени!",
      dateTimeInvalid: "Введённое значение не соответствует формату даты/времени!"
    }
  },
  errors: {
    api: {
      INTERNAL_SERVER_ERROR: "Ошибка сервера",
      VALUE_EXISTS: "Значение '{p}' уже существует",
      USER_NAME_EMPTY: "Имя пользователя обязательно",
      USER_NAME_EXISTS: "Имя пользователя уже существует",
      USER_DISPLAY_NAME_EMPTY: "Название обязательно",
      PASSWORD_EMPTY: "Пароль обязателен",
      PASSWORD_INVALID: "Пароль неверный",
      CONFIRM_PASSWORD_EMPTY: "Необходимо повторно ввести пароль",
      PASSWORD_MISMATCH: "Пароли не совпадают",
      VALUE_EMPTY: "Значение '{p}' должно быть указано!",
      VALUE_INVALID: "В поле '{p}' введено некорректное значение!",
      undefined: "Произошла ошибка",
      //ServiceAct
      DEPARTURE_TIME_MUST_EXCEED_ARRIVAL_TIME: "Время прибытия не может превышать время отправления!",
      //Equipment
      COMPONENT_INSTALLED_AFTER_EQUIPMENT_DEINSTALLATION_DATE: "Дата установки компонента позже указанной даты деинсталляции оборудования!"
    },
  },
};
